import { toast } from '@finn-no/common-browserbundle';
import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', 'favoritesservice'],
    callable(ele, favoritesService) {
        const URL = ele.getAttribute('action');
        const adId = ele.getAttribute('data-ad-id');
        const folderId = ele.querySelector('[name=folderId]').value;
        let timeoutID;
        let ad;

        if (URL) {
            ele.addEventListener('submit', event => {
                event.preventDefault();
                event.stopPropagation();

                ad = document.querySelector(`[data-favorite-ad='${adId}']`);
                prepareDelete();
            });
        }

        function prepareDelete() {
            const timeOut = 4000;
            const msg = createDeleteMessage();
            ad.classList.add('opacity25');
            toast({
                node: msg,
                timeout: timeOut,
            });
            window.addEventListener('beforeunload', performDelete);
            timeoutID = setTimeout(performDelete, timeOut);
        }

        function createDeleteMessage() {
            return el(
                'div',
                { role: 'status' },
                'Sletter favoritten.',
                el(
                    'button.blank',
                    { onclick: () => handleUndoDelete() },
                    'Angre'
                )
            );
        }

        function performDelete() {
            window.removeEventListener('beforeunload', performDelete);
            favoritesService
                .toggleFavorite(folderId, adId, false)
                .then(handleDeleteSuccess, handleDeleteError);
        }

        function handleUndoDelete() {
            clearTimeout(timeoutID);
            window.removeEventListener('beforeunload', performDelete);
            document
                .querySelector('[data-toast-wrapper]')
                .firstElementChild.classList.add('hidden');
            ad.classList.remove('opacity25');
        }

        function handleDeleteSuccess() {
            toast({ message: 'Slettet.', timeout: 1000 });
            ad.remove();
        }

        function handleDeleteError() {
            toast({
                level: 'error',
                message: 'Fikk dessverre ikke slettet. Prøv igjen senere.',
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoriteDelete.js